<template>
  <div>
    <!-- TOTP 코드 입력 -->
    <form v-if="mode === 'totp'" onSubmit="return false;" class="form">
      <h5 class="mb-2">TOTP 인증 / TOTP Verification</h5>
      <p class="text-muted small">
        인증 앱에서 표시된 6자리 코드를 입력하세요. /
        Enter the 6-digit code from your authenticator app.
      </p>

      <div class="form-group">
        <input type="text" id="code" ref="code" class="input" placeholder="123456"
               v-model.trim="code" autocomplete="off" maxlength="6"
               @keyup.enter="onVerify"/>
      </div>

      <button type="button" class="btn-reset" @click="onVerify" :disabled="busy">
        확인 / Verify
      </button>

      <div class="text-muted small mt-2" v-if="errorMsg">{{ errorMsg }}</div>
      <div class="text-muted small mt-2" v-if="lockUntilMsg">{{ lockUntilMsg }}</div>

      <div class="links mt-3">
        <a href="#" @click.prevent="mode = 'recovery'">백업 코드로 로그인 / Use recovery code</a>
        <span> · </span>
        <a href="/" @click.prevent="onCancel">취소 / Cancel</a>
      </div>

      <div class="text-muted xsmall mt-3">
        💡 코드가 계속 일치하지 않으면 스마트폰 시간 자동 설정을 확인해주세요. <br/>
        💡 If code keeps failing, check your phone's time auto-sync setting.
      </div>
    </form>

    <!-- 백업 코드 입력 -->
    <form v-else-if="mode === 'recovery'" onSubmit="return false;" class="form">
      <h5 class="mb-2">백업 코드 입력 / Recovery Code</h5>
      <p class="text-muted small">
        등록 시 발급받은 8자리 백업 코드 중 1개를 입력하세요 (1회용). <br/>
        Enter one of the 8-character recovery codes (one-time use).
      </p>

      <div class="form-group">
        <input type="text" id="recovery_code" ref="recovery_code" class="input recovery-input"
               placeholder="ABCDEFGH" v-model.trim="recovery_code"
               autocomplete="off" maxlength="9" style="text-transform: uppercase;"
               @keyup.enter="onUseRecovery"/>
      </div>

      <button type="button" class="btn-reset" @click="onUseRecovery" :disabled="busy">
        사용 / Use Code
      </button>

      <div class="text-muted small mt-2" v-if="errorMsg">{{ errorMsg }}</div>

      <div class="links mt-3">
        <a href="#" @click.prevent="mode = 'totp'">TOTP 코드로 돌아가기 / Back to TOTP</a>
        <span> · </span>
        <a href="mailto:helpdesk@siliconii.net">관리자 문의 / Contact admin</a>
      </div>
    </form>
  </div>
</template>

<script>
import { lfnVerifyTotp, lfnUseRecoveryCode, lfnRedirectAfterSuccess } from '@/Service/Login/totp';

export default {
  name: 'totpverify',
  data() {
    return {
      mode: 'totp',
      pending_token: '',
      sys_gbn: '',
      code: '',
      recovery_code: '',
      errorMsg: '',
      lockUntilMsg: '',
      busy: false
    };
  },
  mounted() {
    const params = new URL(window.location).searchParams;
    this.pending_token = params.get('token') || '';
    this.sys_gbn = params.get('sys_gbn') || '';
    if (!this.pending_token) {
      alert('잘못된 접근입니다. / Invalid access.');
      window.location.href = '/';
      return;
    }
    this.$nextTick(() => { if (this.$refs.code) this.$refs.code.focus(); });
  },
  methods: {
    async onVerify() {
      if (this.busy) return;
      if (!this.code || this.code.length !== 6) {
        this.errorMsg = '6자리 코드를 입력하세요.';
        return;
      }
      this.busy = true; this.errorMsg = ''; this.lockUntilMsg = '';
      const r = await lfnVerifyTotp(this.pending_token, this.code);
      this.busy = false;
      this.handleResponse(r);
    },
    async onUseRecovery() {
      if (this.busy) return;
      if (!this.recovery_code || this.recovery_code.replace(/-/g, '').length < 8) {
        this.errorMsg = '8자리 백업 코드를 입력하세요.';
        return;
      }
      this.busy = true; this.errorMsg = '';
      const r = await lfnUseRecoveryCode(this.pending_token, this.recovery_code);
      this.busy = false;
      this.handleResponse(r);
    },
    handleResponse(r) {
      if (!r) { this.errorMsg = '응답을 받지 못했습니다.'; return; }
      if (r.err === 0 && r.result === 'S') {
        const ok = lfnRedirectAfterSuccess(r, this.sys_gbn);
        if (!ok) window.location.href = '/';
        return;
      }
      switch (r.result) {
        case 'F_TOTP_PENDING_EXPIRED':
          alert('인증 시간이 만료되었습니다. 처음부터 다시 시도해주세요.');
          window.location.href = '/'; break;
        case 'F_TOTP_LOCKED':
          this.lockUntilMsg = '⚠️ TOTP 가 잠시 잠금되었습니다. 15분 후 다시 시도하거나 백업 코드를 사용하세요.';
          break;
        case 'F_TOTP_REPLAY':
          this.errorMsg = '이미 사용된 코드입니다. 인증 앱에서 새 코드를 확인하세요.'; break;
        case 'F_RECOVERY_LOCKED':
          this.lockUntilMsg = '⚠️ 백업 코드가 잠시 잠금되었습니다. 15분 후 다시 시도하세요.';
          break;
        case 'F_RECOVERY_USED':
          this.errorMsg = '이미 사용된 백업 코드입니다. 다른 코드를 시도하세요.'; break;
        default:
          this.errorMsg = r.resultMsg || r.errMsg || '코드가 일치하지 않습니다.';
      }
    },
    onCancel() { window.location.href = '/'; }
  }
};
</script>

<style scoped>
.btn-reset { width: 100%; padding: 10px; background: #1a73e8; color: #fff; border: 0; border-radius: 4px; cursor: pointer; font-size: 14px; }
.btn-reset:disabled { background: #aaa; }
.input { width: 100%; padding: 8px; border: 1px solid #ccc; border-radius: 4px; font-size: 18px; letter-spacing: 4px; text-align: center; }
.recovery-input { letter-spacing: 2px; }
.links { font-size: 13px; }
.links a { color: #1a73e8; text-decoration: none; }
.links a:hover { text-decoration: underline; }
.text-muted { color: #888; }
.small { font-size: 12px; }
.xsmall { font-size: 11px; }
.form-group { margin: 8px 0; }
</style>
